import { useEffect, useCallback } from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const CALENDLY_URL = "https://calendly.com/contact-jiiastudio/premier-echange-30min";

const CalendlyButton = () => {
  useEffect(() => {
    // Load Calendly widget CSS and JS once
    if (!document.querySelector('link[href*="calendly"]')) {
      const link = document.createElement("link");
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    if (!document.querySelector('script[src*="calendly"]')) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const openCalendly = useCallback(() => {
    if ((window as any).Calendly) {
      (window as any).Calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      window.open(CALENDLY_URL, "_blank");
    }
  }, []);

  return (
    <Button
      type="button"
      onClick={openCalendly}
      className="w-full uppercase tracking-widest font-body text-sm h-14 gap-3 bg-accent text-accent-foreground hover:bg-accent/90 shadow-md hover:shadow-lg transition-all duration-300"
    >
      <Calendar className="h-5 w-5" />
      Prendre rendez-vous
    </Button>
  );
};

export default CalendlyButton;
